import actions from 'actions'
import _ from 'lodash'

const defaultState = {
  deals: null,
}

export default function draftDeals(state = defaultState, action) {
  const { type, deals, data, dealId } = action

  switch (type) {
    case actions.DRAFT_DEALS_EDIT:
      return {
        deals: _.merge({}, deals),
      }
    case actions.DRAFT_DEALS_UPDATE_FIELD:
      return {
        deals: _.mapValues(state.deals, (deal) => {
          if (deal.id === dealId) {
            return Object.assign({}, deal, data)
          }
          return deal
        }),
      }
    case actions.DRAFT_DEALS_CANCEL:
      return defaultState
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/draft-deals/draft-deals.js
 **/